<template>
  <f7-page id="page-sendmoney-payment-summary" name="sendmoney--payment-summary" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="handleBackButton()" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <!-- ALERT MESSAGE -->
      <f7-card
        id     = "errorCard"
        class  = "alert"
        v-show = "alertCard.show"
        :class = "alertCard.alertClass"
        >
          <div v-html="$t(alertCard.title)" slot="header"></div>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>
    </f7-block>

    <f7-block class="mt-xl">
      <!-- PAGE TITLE -->
      <div class="wandr-level-4 mb-20">{{$t(pageTitle)}}</div>

      <!-- TRANSACTION JOURNEY COMPONENT -->
      <transactionJourney class="mb-xl" :key="componentKey" @errorTransactionJourney="errorTransactionJourney($event)" @completeLoadTransactionJourney="completeLoadTransactionJourney($event)" />

      <f7-button style="display:flex;align-items:center;" large fill @click="downloadInvoice()">
        {{$t('sendmoney-btn-download-invoice')}}
      </f7-button>

      <f7-button  class="mt-22 button-fill color-gray6 text-color-green" large outline @click="navigateToHome()">{{$t('general-text-back-to-home')}}</f7-button>
    </f7-block>

  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex"
  import transactionJourney from '@/components/transaction-journey'

  export default {
    components: {
      transactionJourney
    },
    computed: {
      ...mapGetters('auth', [
        'authenticating',
        'authenticationError',
        'authenticationErrorCode',
        'authenticationSuccess'
      ])
    },
    data() {
      return {
        alertCard: {
          show       : false,
          title      : "",
          content    : "",
          alertClass : "alert-danger"
        },
        componentKey        : 0,
        isSettled           : false,
        isShowCancel        : true,
        pageTitle           : "sendmoney-page-title-transfer-created",
        paymentMethodId     : 0,
        transactionId       : 0,
        transactionTypeId   : 0
      }
    },

    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      this.paymentMethodId = this.$store.state.transaction.paymentMethodId

      if(this.$store.state.transaction.isMakePayment){
        this.pageTitle = "my-transaction-details-page-title"
      }

    },

    methods: {
      ...mapActions('auth', ['login']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      completeLoadTransactionJourney(pageTitle){
        this.pageTitle         = pageTitle
        this.alertCard.show    = false
        this.paymentMethodId   = this.$store.state.transaction.paymentMethodId
        this.isSettled         = this.$store.state.transaction.isSettled
        this.transactionId     = this.$store.state.transaction.transactionId
        this.transactionTypeId = this.$store.state.transaction.transactionTypeId
        this.isShowCancel      = this.$store.state.transaction.isShowCancel
      },

      async downloadInvoice(){
        this.showPreloader();
        try {
          const result = await this.$api.transaction.generateInvoice(this.$store.state.transaction.transactionId);
          this.hidePreloader();
          if(result === undefined || result.length <= 0) {
            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            return false;
          }

          if(window.Android) {
            window.Android.getWandrCallback(JSON.stringify({ "type": 'save_pdf_file', "filename": "Wandr-E_" + this.$store.state.transaction.transactionId + "_invoice.pdf", 'data': result.base64,'message': "Invoice Downloaded" }));
          } else if(window.webkit) {
            window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'save_pdf_file', "filename": "Wandr-E_" + this.$store.state.transaction.transactionId + "_invoice.pdf", 'data': result.base64 }));
          } else {
            const dwnElement = document.createElement('a');
            dwnElement.download = "Wandr-E_" + this.$store.state.transaction.transactionId + "_invoice.pdf";
            dwnElement.href = "data:application/pdf;base64," + result.base64;
            document.body.append()
            dwnElement.click()
            dwnElement.remove()
          }
          if(window.Android) {
            console.log("skip here")
          }else{
            this.$f7.toast.create({
              text: 'Invoice downloaded',
              position: 'center',
              closeTimeout: 1000,
            }).open()
          }

        } catch(e){
          this.hidePreloader();
          this.$f7.dialog.alert(e.message);
        }
      },

      errorTransactionJourney(message){
        this.showErrorCard(message)
      },

      navigateToHome(){
        this.showPreloader()
        var transactionData = this.$store.state.transaction
        transactionData.paymentMethodId     = 0
        transactionData.paymentMethod       = ""
        transactionData.transactionIds      = []
        transactionData.transactionTypeIds  = []
        transactionData.settlementId        = 0
        transactionData.totalAmountPayable  = 0
        transactionData.isExpressBankType   = 0
        transactionData.roundedAmount       = 0
        transactionData.hostAmount          = ""
        transactionData.homeAmount          = ""
        transactionData.hostAmountReal      = 0
        transactionData.homeAmountReal      = 0
        transactionData.discountName        = ""
        transactionData.discountAmount      = 0
        transactionData.discountDescription = ""
        transactionData.couponCode          = ""
        transactionData.latestState         = ""
        transactionData.isQuickSend         = false
        transactionData.isMakePayment       = false
        transactionData.convenienceFee      = 0
        transactionData.convenienceTotalFees = 0
        transactionData.convenienceFeeByPercentage = 0

        this.$f7router.navigate("/home")
        this.hidePreloader()
      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },

      forceRerenderTrxJourneyComp(){
        this.componentKey +=1
      },

      handleBackButton(){
        this.$f7router.back({ transition: 'f7-push' })
      }

    }
  }
</script>